module.exports = __webpack_public_path__ + "static/brandedrockcanyon-100010b830940293c1f0a2299701440c.jpg";